import * as ApiManager from './_manager'
import store from '../store';


export const filmRight = {

    create: (payload) => {
        return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/agreement/filmright/create`,payload);
    },

    list: (payload) => {
        return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/agreement/filmright/list`,payload);
    },

    update: (payload) => {
        return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/agreement/filmright/update`,payload);
    },

    delete: (payload) => {
        return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/agreement/filmright/delete`,payload);
    },

}
